<template>
  <div>
    <v-container>
      <v-layout row wrap justify-center>
        <v-flex xs4>
          <standard-autofill :config="serverConfig"></standard-autofill>
        </v-flex>
      </v-layout>
    </v-container>
    <standard-actions
      @save="save"
      @cancel="cancel"
      @close="$emit('close')"
      :save-button="{ name: 'Submit', disabled: !canProceed }"
      :cancel-button="{ name: 'Back' }"
    ></standard-actions>
  </div>
</template>

<script>
import standardActions from '../standardActions'
import standard from '../../autocompletes/standard'

export default {
  name: 'storage',
  components: {
    'standard-actions': standardActions,
    'standard-autofill': standard
  },
  computed: {
    canProceed () {
      return this.serverConfig.id > -1
    }
  },
  data () {
    return {
      serverConfig: {
        id: 0,
        label: 'For Server',
        list: 'servers'
      }
    }
  },
  methods: {
    save () {
      const details = {
        for_server: this.serverConfig.id
      }
      this.$emit('save', details)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
